export default __webpack_public_path__ + "static/media/icon_merchant.c089be2b.svg";